/**
 * Store: Search
 * -----------------------------------------------------------------------------
 * Search page zero result state.
 *
 */
export default {
  namespaced: true,

  state: () => ({
    zeroResults: false,
  }),

  mutations: {

    /**
     * Set state.
     * @param {String} target - Target
     */
    SET_ZERO_RESULTS(state, target) {
      state.zeroResults = target
    },
  },

  actions: {

    /**
     * Commit state.
     * @param {String} target - Target
     */
    setZeroResults({ commit }, target) {
      commit('SET_ZERO_RESULTS', target)
    },
  },
}
